import Vue from 'vue'
import store from '@/store'

Vue.filter('bankName', (val = '') => {
  const rVal = store.getters['choice/getBank'](val)
  return rVal == null ? val : rVal.name
})

Vue.filter('bankShortName', (val = '') => {
  const rVal = store.getters['choice/getBank'](val)
  return rVal == null ? val : rVal.name.replace(/[은행|증권]/g, '')
})
